<template>
  <v-app id="ai-agent-otp-results" class="ai-agent-otp-results">
    <!--begin::Dashboard-->
    <div class="card card-custom card-stretch h-auto px-5 py-5">
      <!--begin::Header-->
      <div class="card-header border-0 py-5 align-items-center">
        <h3 class="card-title align-items-start flex-column m-0 py-3">
          <span class="card-label font-weight-bolder text-dark"
            >AI Agent Call Results for OTPs</span
          >
        </h3>
        <button
          class="btn btn-light font-weight-bolder text-dark-75 position-relative"
          style="z-index: 10 !important"
          v-b-toggle.filter-box
        >
          <v-icon>mdi-tune</v-icon> Filter
        </button>
      </div>
      <!--end::Header-->

      <!-- Dashboard Summary KPIs -->
      <v-row class="mb-6 px-2">
        <!-- Total Calls Triggered for OTP Card -->
        <v-col cols="12" sm="12" md="6" lg="4" class="pa-2">
          <v-card
            class="rounded-xl elevation-8 transition-swing h-100"
            style="border-top: 6px solid #2196f3; overflow: hidden"
          >
            <v-card-title
              class="blue--text d-flex justify-space-between align-center pa-3"
              style="flex-wrap: nowrap; min-height: 60px"
            >
              <div
                class="d-flex align-center flex-shrink-1"
                style="min-width: 0"
              >
                <v-icon left color="blue darken-2" size="24" class="mr-2">
                  mdi-bell
                </v-icon>
                <span
                  class="font-weight-bold subtitle-1"
                  style="word-break: break-word; line-height: 1.2"
                >
                  Total Calls Triggered for OTP
                </span>
              </div>
              <div
                class="d-flex align-center text-h5 font-weight-bold blue--text text--darken-1 flex-shrink-0 ml-3"
              >
                {{ otpStatistics?.total_calls }}
              </div>
            </v-card-title>
            <v-divider class="m-0"></v-divider>
            <v-card-text class="px-3 py-2">
              <v-row dense>
                <v-col cols="12" class="px-2 py-1">
                  <div
                    class="d-flex flex-row align-center justify-space-between green--text pa-2 rounded-lg"
                    style="background-color: rgba(76, 175, 80, 0.08)"
                  >
                    <div class="d-flex flex-column">
                      <div class="d-flex align-center">
                        <v-icon color="green darken-2" size="20" class="mr-2">
                          mdi-phone-outgoing
                        </v-icon>
                        <span class="font-weight-medium body-2">Initiated</span>
                      </div>
                      <span class="caption grey--text ml-7">Sent to Velents and no response is received yet</span>
                    </div>
                    <div class="text-h6 font-weight-bold">
                      {{ otpStatistics?.initiated_calls || 0 }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" class="px-2 py-1">
                  <div
                    class="d-flex flex-row align-center justify-space-between green--text pa-2 rounded-lg"
                    style="background-color: rgba(76, 175, 80, 0.08)"
                  >
                    <div class="d-flex flex-column">
                      <div class="d-flex align-center">
                        <v-icon color="green darken-2" size="20" class="mr-2">
                          mdi-check-circle
                        </v-icon>
                        <span class="font-weight-medium body-2">Completed</span>
                      </div>
                      <span class="caption grey--text ml-7">Response is received from Velents</span>
                    </div>
                    <div class="text-h6 font-weight-bold">
                      {{ otpStatistics?.completed_calls || 0 }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" class="px-2 py-1">
                  <div
                    class="d-flex flex-row align-center justify-space-between red--text pa-2 rounded-lg"
                    style="background-color: rgba(244, 67, 54, 0.08)"
                  >
                    <div class="d-flex flex-column">
                      <div class="d-flex align-center">
                        <v-icon color="red darken-2" size="20" class="mr-2">
                          mdi-alert-circle
                        </v-icon>
                        <span class="font-weight-medium body-2">Total Calls with Issues</span>
                      </div>
                      <span class="caption grey--text ml-7">1-hr passed and no response is received</span>
                    </div>
                    <div class="text-h6 font-weight-bold">
                      {{ otpStatistics?.calls_with_issues || 0 }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Completed Calls Card -->
        <v-col cols="12" sm="12" md="6" lg="4" class="pa-2">
          <v-card
            class="rounded-xl elevation-8 transition-swing h-100"
            style="border-top: 6px solid #ffc107; overflow: hidden"
          >
            <v-card-title
              class="amber--text d-flex justify-space-between align-center pa-3"
              style="flex-wrap: nowrap; min-height: 60px"
            >
              <div
                class="d-flex align-center flex-shrink-1"
                style="min-width: 0"
              >
                <v-icon left color="amber darken-2" size="24" class="mr-2">
                  mdi-bell
                </v-icon>
                <span
                  class="font-weight-bold subtitle-1"
                  style="word-break: break-word; line-height: 1.2"
                >
                  Completed Calls
                </span>
              </div>
              <div
                class="d-flex align-center text-h5 font-weight-bold amber--text text--darken-1 flex-shrink-0 ml-3"
              >
                {{ otpStatistics?.completed_calls || 0 }}
              </div>
            </v-card-title>
            <v-divider class="m-0"></v-divider>
            <v-card-text class="px-3 py-2">
              <v-row dense>
                <v-col cols="12" class="px-2 py-1">
                  <div
                    class="d-flex flex-row align-center justify-space-between blue--text pa-2 rounded-lg"
                    style="background-color: rgba(33, 150, 243, 0.08)"
                  >
                    <div class="d-flex flex-column">
                      <div class="d-flex align-center">
                        <v-icon color="blue darken-2" size="20" class="mr-2">
                          mdi-phone-in-talk
                        </v-icon>
                        <span class="font-weight-medium body-2">Answered</span>
                      </div>
                      <span class="caption grey--text ml-7">Response received from Velents with output status Answered</span>
                    </div>
                    <div class="text-h6 font-weight-bold">
                      {{ otpStatistics?.answered_calls || 0 }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" class="px-2 py-1">
                  <div
                    class="d-flex flex-row align-center justify-space-between red--text pa-2 rounded-lg"
                    style="background-color: rgba(244, 67, 54, 0.08)"
                  >
                    <div class="d-flex flex-column">
                      <div class="d-flex align-center">
                        <v-icon color="red darken-2" size="20" class="mr-2">
                          mdi-phone-off
                        </v-icon>
                        <span class="font-weight-medium body-2">No Answer</span>
                      </div>
                      <span class="caption grey--text ml-7">Response received from Velents but the talent didn't answer or cancelled or unreachable</span>
                    </div>
                    <div class="text-h6 font-weight-bold">
                      {{ otpStatistics?.not_answered_calls || 0 }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Total Calls with Issues Card -->
        <v-col cols="12" sm="12" md="6" lg="4" class="pa-2">
          <v-card
            class="rounded-xl elevation-8 transition-swing h-100"
            style="border-top: 6px solid #f44336; overflow: hidden"
          >
            <v-card-title
              class="red--text d-flex justify-space-between align-center pa-3"
              style="flex-wrap: nowrap; min-height: 60px"
            >
              <div
                class="d-flex align-center flex-shrink-1"
                style="min-width: 0"
              >
                <v-icon left color="red darken-2" size="24" class="mr-2">
                  mdi-bell-off
                </v-icon>
                <span
                  class="font-weight-bold subtitle-1"
                  style="word-break: break-word; line-height: 1.2"
                >
                  Total Calls with Issues
                </span>
              </div>
              <div
                class="d-flex align-center text-h5 font-weight-bold red--text text--darken-1 flex-shrink-0 ml-3"
              >
                {{ otpStatistics?.calls_with_issues || 0 }}
              </div>
            </v-card-title>
            <v-divider class="m-0"></v-divider>
            <v-card-text class="px-3 py-2">
              <v-row dense>
                <v-col cols="12" class="px-2 py-1">
                  <div
                    class="d-flex flex-row align-center justify-space-between blue--text pa-2 rounded-lg"
                    style="background-color: rgba(33, 150, 243, 0.08)"
                  >
                    <div class="d-flex align-center">
                      <v-icon color="blue darken-2" size="20" class="mr-2">
                        mdi-close-circle-outline
                      </v-icon>
                      <span class="font-weight-medium body-2"
                        >Still not Verified</span
                      >
                    </div>
                    <div class="text-h6 font-weight-bold">
                      {{ otpStatistics?.with_issues_not_verified || 0 }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text class="px-3 py-2">
              <v-row dense>
                <v-col cols="12" class="px-2 py-1">
                  <div
                    class="d-flex flex-row align-center justify-space-between blue--text pa-2 rounded-lg"
                    style="background-color: rgba(33, 150, 243, 0.08)"
                  >
                    <div class="d-flex align-center">
                      <v-icon color="blue darken-2" size="20" class="mr-2">
                        mdi-close-circle-outline
                      </v-icon>
                      <span class="font-weight-medium body-2"
                        >With Issues but Verified</span
                      >
                    </div>
                    <div class="text-h6 font-weight-bold">
                      {{ otpStatistics?.with_issues_verified || 0 }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- Filters and Table Section -->
    <div class="card card-custom card-stretch h-auto">
      <AIAgentOTPResultsFilter
        @applyFilter="applyFilter"
        @resetQuery="resetQuery"
      />

      <div class="card-body pt-0 pb-3">
        <div class="tab-content">
          <!--begin::Table-->
          <div
            class="table-responsive mb-0"
            v-if="otpCallResults && otpCallResults.length > 0"
          >
            <table
              class="table table-head-custom table-vertical-center table-head-bg table-borderless"
            >
              <thead>
                <tr class="text-left">
                  <th style="width: 150px">Talent Name</th>
                  <th style="width: 130px">Talent Role</th>
                  <th style="width: 180px">Email</th>
                  <th style="width: 140px">Phone Number</th>
                  <th style="width: 180px">Call Trigger Date and Time</th>
                  <th style="width: 150px">Provider Status</th>
                  <th style="width: 130px">Output Status</th>
                  <th style="width: 130px">Call Status</th>
                  <th style="width: 120px" class="text-center">
                    Phone Verified
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="call in otpCallResults"
                  :key="`${call.id || call.talent_id}-${call.phone}-${
                    call.created_at
                  }`"
                  @click="handleClickCallRecord(call?.response?.result?.recording)"
                  class="pointer-cursor"
                >
                  <td>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          class="text-dark-75 font-weight-bolder font-size-lg text-clamp-2"
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ call.talent_name || "N/A" }}
                        </span>
                      </template>
                      <span>{{ call.talent_name || "N/A" }}</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          class="text-dark-75 font-weight-bolder font-size-lg text-clamp-2 truncate-text"
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ call.talent_role || "N/A" }}
                        </span>
                      </template>
                      <span>{{ call.talent_role || "N/A" }}</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <span class="text-dark-75 font-weight-bolder font-size-lg">
                      {{ call.email || "N/A" }}
                    </span>
                  </td>
                  <td>
                    <span class="text-dark-75 font-weight-bolder font-size-lg">
                      {{ call.phone_number || "N/A" }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder font-size-lg"
                      style="min-width: max-content"
                    >
                      {{ formatCallTriggerDateTime(call.initiated_at) }}
                    </span>
                  </td>
                  <td>
                    <v-chip
                      :color="getProviderStatusColor(call.provider_status)"
                      :text-color="
                        getProviderStatusTextColor(call.provider_status)
                      "
                      pill
                      small
                    >
                      {{ getProviderStatusDisplay(call.provider_status) }}
                    </v-chip>
                  </td>
                  <td>
                    <v-chip
                      :color="getOutputStatusColor(call.output_status)"
                      :text-color="getOutputStatusTextColor(call.output_status)"
                      :style="
                        call.output_status === 'answered'
                          ? 'cursor: pointer'
                          : 'cursor: default'
                      "
                      pill
                      small
                      @click.stop="
                        call.output_status === 'answered' &&
                          handleClickCallRecord(
                            call?.response?.result?.recording
                          )
                      "
                    >
                      {{ getOutputStatusDisplay(call.output_status) }}
                    </v-chip>
                  </td>
                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder font-size-lg text-clamp-2"
                      style="min-width: max-content"
                    >
                      {{ getCallStatusDisplay(call.call_status) }}
                    </span>
                  </td>
                  <td class="text-center" @click.stop>
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      <img
                        v-if="call.phone_verified"
                        src="@/assets/images/verified.png"
                        alt="Verified"
                        width="19"
                        height="auto"
                        v-b-tooltip="'Mobile number verified successfully'"
                      />
                      <img
                        v-else
                        src="@/assets/images/un-verified.png"
                        alt="Not Verified"
                        width="24"
                        height="24"
                        v-b-tooltip="'Mobile number not verified'"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <h5
            class="my-5 text-muted text-center"
            v-if="!otpCallResults || otpCallResults.length === 0"
          >
            No Results Found
          </h5>
          <!--end::Table-->
        </div>
      </div>
      <!--end::Body-->
    </div>

    <!-- Call Recording Modal -->
    <v-dialog v-model="dialogVisible" max-width="500">
      <v-card>
        <v-card-title>Call Recording</v-card-title>
        <v-card-text class="d-flex justify-center">
          <!-- Audio player -->
          <audio controls :src="audioUrl" v-if="audioUrl"></audio>
          <v-alert
            border="right"
            colored-border
            type="error"
            elevation="2"
            v-else
          >
            No recordings were found.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="handleCloseDialog">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="audioUrl"
            color="primary"
            text
            :href="audioUrl"
            target="_blank"
          >
            Open in New Tab
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Pagination Component -->
    <div class="pagination-container">
      <p
        v-if="otpCallResults && otpCallResults.length > 0"
        class="pagination-container__desc"
      >
        {{
          $t("showing_results", {
            length: `${otpCallResultsMeta?.from || 0} - ${
              otpCallResultsMeta?.to || 0
            }`,
            total: otpCallResultsMeta?.total || 0,
          })
        }}
      </p>
      <b-pagination
        v-if="otpCallResultsMeta && otpCallResultsMeta.last_page > 1"
        v-model="page"
        :total-rows="otpCallResultsMeta.total"
        :per-page="perPage"
        align="center"
        last-number
        first-number
        @change="handlePageChange"
      ></b-pagination>
    </div>
    <!--end::Dashboard-->
  </v-app>
</template>

<script>
import AIAgentOTPResultsFilter from "@/components/ai-agent-otp-results/AIAgentOTPResultsFilter.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AIAgentOTPResults",
  components: {
    AIAgentOTPResultsFilter,
  },
  data() {
    return {
      page: 1,
      perPage: 10,
      filters: {},
      audioUrl: null,
      dialogVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      otpCallResults: "aiAgentOTP/getOTPCalls",
      otpCallResultsMeta: "aiAgentOTP/getOTPCallsMeta",
      otpStatistics: "aiAgentOTP/getOTPStats",
    }),
    otpCallResultsQuery() {
      return {
        page: this.page,
        perPage: this.perPage,
        ...this.filters,
      };
    },
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.audioUrl = null;
      }
    },
    page() {
      this.fetchOTPCallResults(this.otpCallResultsQuery);
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dashboard", route: "/dashboard" },
      { title: "AI Agent Call Results for OTPs" },
    ]);
    this.fetchOTPCallResults(this.otpCallResultsQuery);
    this.fetchOTPStatistics();
  },
  methods: {
    ...mapActions({
      fetchOTPCallResults: "aiAgentOTP/fetchOTPCallResults",
      fetchOTPStatistics: "aiAgentOTP/fetchOTPStatistics",
    }),
    applyFilter(data) {
      this.filters = { ...data };
      this.page = 1;
      this.fetchOTPCallResults({
        page: 1,
        perPage: this.perPage,
        ...data,
      });
    },
    resetQuery() {
      this.filters = {};
      this.page = 1;
      this.fetchOTPCallResults({
        page: 1,
        perPage: this.perPage,
      });
    },
    getOutputStatusDisplay(status) {
      if (!status) return "N/A";
      return status
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/\b\w/g, (c) => c.toUpperCase());
    },
    getProviderStatusDisplay(status) {
      if (!status) return "N/A";
      return status
        .replace(/_/g, " ")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .toLowerCase()
        .replace(/\b\w/g, (c) => c.toUpperCase());
    },
    getProviderStatusColor(status) {
      if (!status) return "#FFC107";
      switch (status) {
        case "done":
          return "#4CAF50";
        case "OnProcess":
        case "on_process":
          return "#2196F3";
        case "no_response":
        case "busy_here":
        case "expired":
        case "Invalid_Number":
        case "invalid_number":
        case "temporarily_unavailable":
        case "ended_immediately":
        case "network_issue":
        case "timed_out":
        case "failed":
          return "#f44336";
        default:
          return "#f44336";
      }
    },
    getProviderStatusTextColor(status) {
      if (!status) return "#854d0e";
      switch (status) {
        case "done":
          return "#166534";
        case "OnProcess":
        case "on_process":
          return "#0b3d91";
        case "no_response":
        case "busy_here":
        case "expired":
        case "Invalid_Number":
        case "invalid_number":
        case "temporarily_unavailable":
        case "ended_immediately":
        case "network_issue":
        case "timed_out":
        case "failed":
          return "#991b1b";
        default:
          return "#991b1b";
      }
    },
    getOutputStatusColor(status) {
      switch (status) {
        case "ACHIEVED":
        case "answered":
          return "#4CAF50";
        case "NO_ANSWER":
        case "not_answered":
          return "#f44336";
        case "NOT_ACHIEVED":
        case "unreachable":
          return "#f44336";
        default:
          return "warning";
      }
    },
    getOutputStatusTextColor(status) {
      switch (status) {
        case "answered":
        case "ACHIEVED":
          return "#166534";
        case "no_answer":
        case "NO_ANSWER":
        case "not_answered":
          return "#991b1b";
        case "NOT_ACHIEVED":
        case "unreachable":
          return "#9a3412";
        default:
          return "#334155";
      }
    },
    formatCallTriggerDateTime(value) {
      if (!value) return "N/A";
      const date = new Date(value);
      if (isNaN(date.getTime())) return "N/A";
      return date.toLocaleString("en-GB", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    },
    getCallStatusDisplay(status) {
      if (!status) return "N/A";
      return status
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/\b\w/g, (c) => c.toUpperCase());
    },
    handlePageChange(page) {
      this.page = page;
      this.fetchOTPCallResults(this.otpCallResultsQuery);
    },
    handleClickCallRecord(recordUrl) {
      this.audioUrl = recordUrl;
      this.dialogVisible = true;
    },
    handleCloseDialog() {
      this.audioUrl = null;
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive table {
  min-width: 900px;
}
.table-responsive th,
.table-responsive td {
  white-space: nowrap;
}
.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .ai-agent-otp-results ::v-deep .card-body {
    padding-left: 12px;
    padding-right: 12px;
  }
  .ai-agent-otp-results ::v-deep .card-header {
    padding-left: 12px;
    padding-right: 12px;
  }
  .ai-agent-otp-results ::v-deep .card.px-5 {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
  .ai-agent-otp-results ::v-deep .card-title {
    font-size: 1rem;
  }
  .table-responsive {
    margin-left: -12px;
    margin-right: -12px;
    padding-left: 12px;
    padding-right: 12px;
    background:
      linear-gradient(to right, #fff 30%, rgba(255, 255, 255, 0)),
      linear-gradient(to right, rgba(255, 255, 255, 0), #fff 70%) 100% 0,
      linear-gradient(to right, rgba(0, 0, 0, 0.08), rgba(255, 255, 255, 0)),
      linear-gradient(to left, rgba(0, 0, 0, 0.08), rgba(255, 255, 255, 0)) 100% 0;
    background-repeat: no-repeat;
    background-size: 24px 100%, 24px 100%, 12px 100%, 12px 100%;
    background-attachment: local, local, scroll, scroll;
  }
  .pagination-container {
    padding: 12px;
  }
}
.pointer-cursor {
  cursor: pointer;
}
.pointer-cursor:hover {
  background-color: rgba(0, 0, 0, 0.02);
}
.pagination-container {
  margin-top: 20px;
  padding: 20px;
}
.pagination-container__desc {
  text-align: center;
  margin-bottom: 10px;
}
</style>
